<template>
  <div class="select" :class="className" v-click-outside="hideList">
    <div class="select__label">{{label}}</div>
    <div class="select__input" @click="toggleList">
      <div class="select__value" :class="{placeholder : selected === null}">{{ value }}</div>
      <BaseIcon icon="chevron-down" />
    </div>
    <transition name="fadeUp">
      <BaseSelectList v-if="isOpen" :items="options" :active="selected" @onSelect="setOption" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    className: {
      type: String,
    },
    selected: {
      type: Object,
      validator: obj => {
        return ['id', 'value', 'name', 'label'].every(field => Object.keys(obj).includes(field));
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    label: {
      type: String,
      defualt: '',
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    value() {
      return this.selected ? this.selected.name : this.placeholder;
    },
  },
  methods: {
    toggleList() {
      this.isOpen = !this.isOpen;
    },
    hideList() {
      this.isOpen = false;
    },
    setOption(option) {
      this.$emit('onOptionChange', option);
      this.hideList();
    },
  },
};
</script>

<style lang="scss">
.select {
  height: 4rem;
  border-radius: 5rem;
  background-color: $bg;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  cursor: pointer;

  &__label {
    position: absolute;
    top: -2rem;
    color: $dark;
    font-weight: 500;
  }

  &__value {
    font-size: 1.2rem;
    font-weight: 500;
    color: $grey;

    &.placeholder {
      font-style: italic;
      font-weight: 400;
      opacity: 0.8;
    }
  }

  &__input {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    margin-left: auto;
    width: 1.5rem;
    fill: $grey;
  }

  &.width-90 {
    max-width: 90%;
  }
}
</style>
